// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vD-z","smallCardRow":"wD-z","largeCardRow":"xD-z","productSearchRow":"yD-z","curatedRow":"zD-z"};